import React, { useEffect, lazy, Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SidebarProvider } from '../context/SidebarContext';
import SidebarContainer from '../components/common/SidebarContainer';
import ContentContainer from '../components/common/ContentContainer';
import '../styles/global-sidebar.css';

const MasterEstablishmentsDashboard = lazy(() =>
  import('../components/master/MasterEstablishmentsDashboard')
);
const MasterAIDashboard = lazy(() =>
  import('../components/master/MasterAIDashboard')
);
const MasterTicketsManagement = lazy(() =>
  import('../components/master/MasterTicketsManagement')
);
const MasterUsersManagement = lazy(() =>
  import('../components/master/MasterUsersManagement')
);
const TenantManagement = lazy(() =>
  import('../components/master/TenantManagement')
);
const AcademicContentManagement = lazy(() =>
  import('../components/admin/AcademicContentManagement')
);

const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Cargando...</span>
    </Spinner>
  </div>
);

const MasterView = () => {
  useEffect(() => { document.title = 'Artemis — Vista Maestra'; }, []);

  return (
    <SidebarProvider>
      <div className="global-layout">
        <SidebarContainer />
        <ContentContainer>
          <div className="global-content-body">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Navigate to="/master/dashboard/establishments" replace />} />
                <Route path="/dashboard/establishments" element={<MasterEstablishmentsDashboard />} />
                <Route path="/dashboard/ai" element={<MasterAIDashboard />} />
                <Route path="/tickets" element={<MasterTicketsManagement />} />
                <Route path="/users" element={<MasterUsersManagement />} />
                <Route path="/tenants" element={<TenantManagement />} />
                <Route path="/academic-content" element={<AcademicContentManagement variant="master" />} />
              </Routes>
            </Suspense>
          </div>
        </ContentContainer>
      </div>
    </SidebarProvider>
  );
};

export default MasterView;
